'use client'

import { memo } from 'react'
import { cartPickupStoreSelector, TPickupPersonInformation } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

import { MilpitasStoreIcon, PersonInformationIcon } from '@/components/icons'

/**
 * 结算页 Pickup Address 信息组件
 * @param {object} [pickupPersonInformation] - Pickup信息
 *
 * @returns {JSX.Element} Form表单组件
 */
const PickupAddress = ({
  pickupPersonInformation,
}: {
  pickupPersonInformation: TPickupPersonInformation | null
}) => {
  const cartStore = useAppSelector(cartPickupStoreSelector)

  return (
    <div className="rounded-[12px] bg-white px-3 py-4 xl:p-0">
      <p className="mb-3 text-[16px] xl:text-[20px]">Pickup Address</p>
      <div className="rounded-[8px] bg-[#F8F8F9] p-3 xl:p-[20px]">
        <div className="flex items-center">
          <MilpitasStoreIcon />
          <span className="mb-[-4px] ml-2 xl:text-[16px]">{cartStore?.store_name ?? ''}</span>
        </div>
        <div className="mt-[12px] space-y-1 text-[14px] text-[#6E6E73]">
          {/* TODO */}
          {/*<p>22.1 miles</p>*/}
          <p>{cartStore?.address ?? ''}</p>
          <p>
            {`${cartStore?.city ?? ''}, ${cartStore?.region?.name ?? ''}, ${cartStore?.zipcode ?? ''}, ${cartStore?.country_name ?? ''}`}
          </p>
        </div>
        {pickupPersonInformation && (
          <>
            <div className="my-4 border-b border-[#E1E1E4] xl:my-5" />
            <div className="flex items-center">
              <PersonInformationIcon />
              <span className="ml-2 xl:text-[16px]">Pickup Person Information</span>
            </div>
            <div className="mt-[12px] space-y-1 text-[14px] text-[#6E6E73]">
              <p>{`${pickupPersonInformation?.firstname ?? ''} ${pickupPersonInformation?.lastname ?? ''}`}</p>
              <p>{pickupPersonInformation?.email ?? ''}</p>
              <p>{pickupPersonInformation?.telephone ?? ''}</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default memo(PickupAddress)
